var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormalMessageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.005,
    height: 7.411,
    viewBox: "0 0 7.005 7.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "suitcase_curved",
    transform: "translate(-31.75 -23.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83764",
    "data-name": "Path 83764",
    d: "M35.252,28.472v-.813m0,.813v.813m0-.813c-1.626,0-3.252-.407-3.227-1.22m3.227,1.22c1.626,0,3.252-.407,3.227-1.22m-6.455,0c-.016.257-.025.531-.025.813a5.926,5.926,0,0,0,.361,2.53,8.656,8.656,0,0,0,2.891.316,8.656,8.656,0,0,0,2.891-.316,5.926,5.926,0,0,0,.361-2.53c0-.282-.009-.556-.025-.813m-6.455,0a4,4,0,0,1,.336-1.717,7.54,7.54,0,0,1,1.671-.278m4.447,1.995a4,4,0,0,0-.336-1.717,7.54,7.54,0,0,0-1.671-.278m-2.439,0c.375-.024.789-.038,1.22-.038s.845.014,1.22.038m-2.439,0v-.444c0-.722.666-.813,1.22-.813s1.22.091,1.22.813v.444",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormalMessageIcon);
export default __webpack_public_path__ + "static/media/formal-message-icon.30caede0d9c4504981a913beb6d6a4ab.svg";
export { ForwardRef as ReactComponent };